$(document).ready(function() {
  $(document).on('click', '.search-opener', function(e) {
    e.preventDefault();
    $('#Search-drawer-button-header').trigger('click');
  });
});

$(document).on('click', '.header__utils-item--wishlist a', function(e) {
  e.preventDefault();
  $('button[aria-label="open-wishlist"]').trigger('click');
});

$(document).ready(function() {
  $(".aw-featured-products").each(function() {
    const $container = $(this);

    function updateLink() {
      $container.find("[class*='products-feed__tabcontent']").each(function() {
        if ($(this).css("display") === "block") {
          var href = $(this).find(".card-product-slider__link").attr("href");
          if (href) {
            $container.find(".section__head--buttons a").attr("href", href);
          }
        }
      });
    }

    updateLink();

    const targetNodes = $container.find("[class*='products-feed__tabcontent']").get();
    targetNodes.forEach(node => {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(mutation => {
          if (mutation.attributeName === "style") {
            updateLink();
          }
        });
      });
      observer.observe(node, {
        attributes: true,
        attributeFilter: ["style"]
      });
    });
  });
});

$(document).ready(function() {
  $(document).on('click', '.product-option__input', function(e) {
    if (!$(this).prop('checked')) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const inputName = $(this).attr('name');
      const inputVal = $(this).val();

      const url = new URL(window.location.href);
      const params = url.searchParams;

      const values = params.getAll(inputName);

      const newValues = values.filter(v => v !== inputVal);

      params.delete(inputName);

      newValues.forEach(v => params.append(inputName, v));

      window.location.href = url.toString();
    }
  });
});